import { render, staticRenderFns } from "./DialogFormClientAdd.vue?vue&type=template&id=954ad210"
import script from "./DialogFormClientAdd.vue?vue&type=script&lang=js"
export * from "./DialogFormClientAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports